import { render } from "./vhpListCard.vue?vue&type=template&id=0563abe3&scoped=true"
import script from "./vhpListCard.vue?vue&type=script&lang=js"
export * from "./vhpListCard.vue?vue&type=script&lang=js"

import "./vhpListCard.scss?vue&type=style&index=0&id=0563abe3&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0563abe3"]])

export default __exports__